/* Dawn loads <product-recommendations> from an IntersectionObserver created in its
   constructor. The element starts empty, so it collapses to almost no height and the
   observer can fail to fire - leaving the section permanently blank even though the
   endpoint returns products. This retries once if it is still empty, using exactly
   Dawn's own parse-and-inject logic. It is a no-op whenever Dawn succeeds. */
(function () {
  function hydrate(el) {
    if (!el || !el.dataset.url || el.dataset.aurumTried) return;
    if (el.querySelector('.card-wrapper')) return;          // Dawn already filled it
    el.dataset.aurumTried = '1';
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var box = document.createElement('div');
        box.innerHTML = text;
        var rec = box.querySelector('product-recommendations');
        if (rec && rec.innerHTML.trim().length) el.innerHTML = rec.innerHTML;
        if (!el.querySelector('.grid__item')) el.remove();   // genuinely nothing to show
      })
      .catch(function () {});
  }
  function run() {
    document.querySelectorAll('product-recommendations').forEach(function (el) {
      // give Dawn a chance first; only step in if it has not filled the section
      setTimeout(function () { hydrate(el); }, 1200);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
